import * as Yup from 'yup';
export const CreateCarrierSchema = Yup.object({
  name: Yup.string().trim().required('Carrier name is required'),
  logo: Yup.mixed()
    .test('logo-required', 'Logo is required', value => {
      // Allow either a non-empty string or a valid object
      return typeof value === 'string' || (value && typeof value === 'object');
    })
    .required('Logo is required'),
});

// export const UpdateCarrierSchema = Yup.object().shape({});
